import { call, put, takeEvery, takeLatest, delay } from "redux-saga/effects"

// Login Redux States
import { LOGIN_SU_USER, LOGOUT_SU_USER, SOCIAL_SU_LOGIN } from "./constant"
import { apiSuperUserError, loginSuperSuccess, logoutSuperUserSuccess } from "./action"

import { loginUserApi } from "./api"



function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield call(loginUserApi, user)

    yield put(loginSuperSuccess(response))
    if (response.data.status === 1) {
      localStorage.setItem("authUser", JSON.stringify(response.data.token));
      localStorage.setItem("WWINGS_USER_TYPE", JSON.stringify(response.data.role))
      history("/super/admin/dashboard")
    } else if (response.status === 0) {
      history("/super/admin/login")
      yield put(apiSuperUserError(response.data.message))
    }
  } catch (error) {
    yield put(apiSuperUserError(error.response.data.message))
  }
}

function* logoutUser({ payload: { history } }) {
  try {
  
    localStorage.clear()
    yield put(logoutSuperUserSuccess())

    history("/super/admin/login")
    yield delay(200)
    window.location.reload()

  } catch (error) {
    yield put(apiSuperUserError(error))
  }
}

function* socialLogin({ payload: { type, history } }) {
  try {


    const response = yield call(fireBaseBackend.socialLoginUser, type)
    if (response) {
      history("/dashboard")
    } else {
      history("/login")
    }
    localStorage.setItem("authUser", JSON.stringify(response))
    yield put(loginSuperSuccess(response))


  } catch (error) {
    console.log("error", error)
    yield put(apiSuperUserError(error))
  }
}

function* SuperUserAuthSaga() {
  yield takeEvery(LOGIN_SU_USER, loginUser)
  yield takeLatest(SOCIAL_SU_LOGIN, socialLogin)
  yield takeEvery(LOGOUT_SU_USER, logoutUser)
}

export default SuperUserAuthSaga;
